import { BlockWrapper, defineBlock } from "@smartfire/js-block-engine";
import clsx from "clsx";
import he from "he";
import StatusBar from "./StatusBar";
import { SubMenu } from "../../components";
import style from "./block.module.scss";

const Block = ({
  title,
  universes,
  initialNbProducts,
  initialFilters,
  description = null,
}) => (
  <BlockWrapper.Div className={style.block}>
    <div className={style.top}>
      <h1 className={style.title}>{he.decode(title) ?? ""}</h1>

      {description && (
        <div
          className={style.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

      {universes?.length > 0 && (
        <SubMenu arrowLeftBgColor={style.lightBeige}>
          {universes.map((universe) => (
            <a
              key={`universe-key-${universe.id}`}
              href={universe.link ?? undefined}
              className={clsx(style.universe, universe.active && style.active)}
            >
              {he.decode(universe.title) ?? ""}
            </a>
          ))}
        </SubMenu>
      )}
    </div>

    <StatusBar
      initialNbProducts={initialNbProducts}
      initialFilters={initialFilters}
    />
  </BlockWrapper.Div>
);

export default defineBlock({
  Block,
});
